import api from "./client";
import {
  MALNUTRITION_USE_MOCKS,
  mockGetMalnutritionRiskAssessment,
  mockGetPatientWeights,
} from "./mocks/malnutrition-fixtures";

import type {
  MalnutritionRiskAssessment,
  PatientWeightHistory,
} from "../types/Malnutrition";

export const getMalnutritionRiskAssessment = async (
  emrPatientID: string
): Promise<MalnutritionRiskAssessment> => {
  if (MALNUTRITION_USE_MOCKS) return mockGetMalnutritionRiskAssessment(emrPatientID);
  const response = await api.get("/malnutrition-risk/", {
    params: { emr_patient_id: emrPatientID },
  });
  return response?.data;
};

export const getPatientWeights = async (
  emrPatientID: string
): Promise<PatientWeightHistory> => {
  if (MALNUTRITION_USE_MOCKS) return mockGetPatientWeights(emrPatientID);
  const response = await api.get("/patient-weights/", {
    params: { emr_patient_id: emrPatientID },
  });
  return response?.data;
};
